import {
  whatIfOrDefaultSelector,
  whatIfInnerSelector,
} from '../../WhatIfsSelector';
import { createSelector } from 'reselect';

export const principalName = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.PrincipalName;
};
export const partnerName = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return whatIfOptions.SpouseName;
};
export const hasPartner = (state, props) => !!partnerName(state, props);

export const principalOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.PrincipalRetirementAgeOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};
export const partnerOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  return (whatIfOptions.SpouseRetirementAgeOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};
export const principalIsRetiredSelector = (state, props) =>
  !!whatIfInnerSelector(state, props).PrincipalIsRetired;
export const partnerIsRetiredSelector = (state, props) =>
  !!whatIfInnerSelector(state, props).SpouseIsRetired;
export const principalAge = createSelector(
  principalIsRetiredSelector,
  principalOptions,
  whatIfInnerSelector,
  (isRetired, ageOpts, { RetirementAgePrincipal }) =>
    (isRetired && ageOpts[0] ? ageOpts[0].value : RetirementAgePrincipal),
);
export const partnerAge = createSelector(
  partnerIsRetiredSelector,
  partnerOptions,
  whatIfInnerSelector,
  (isRetired, ageOpts, { RetirementAgeSpouse }) =>
    (isRetired && ageOpts[0] ? ageOpts[0].value : RetirementAgeSpouse),
);
